module.exports = __webpack_public_path__ + "media/images/countrysquared/bb-259f7c1082476de351d02fe9a337a5ab.svg";